import React, { forwardRef } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { LineChartItem } from "@interfaces/analysis";
import { formatReportDate } from "@utils/date";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  xAxes: {
    title: "time",
    gridThickness: 2,
    unit: "day",
    unitStepSize: 1000,
    type: "time",
    time: {
      displayFormats: {
        millisecond: "MMM DD",
        second: "MMM DD",
        minute: "MMM DD",
        hour: "MMM DD",
        day: "MMM DD",
        week: "MMM DD",
        month: "MMM DD",
        quarter: "MMM DD",
        year: "MMM DD",
      },
    },
  },
  plugins: {
    legend: {
      position: "top" as const,
    },
    title: {
      display: true,
      text: "Chart.js Line Chart",
    },
  },
};

interface LineChartProps {
  dataSeries: LineChartItem[][];
}

const colours = [
  "#90CAF9",
  "#2196F3",
  "#1565C0",
  "#69F0AE",
  "#F44336",
  "#FFAB91",
  "#FFE57F",
];

export const LineChart = forwardRef(({ dataSeries }: LineChartProps, ref) => {
  let labels: string[] = [];
  for (const data of dataSeries) {
    labels = data.map((d) => formatReportDate(d.x));
    break;
  }
  const data = {
    labels,
    datasets: dataSeries.map((dataSeriesItem, index) => {
      return {
        label: `Dataset ${index}`,
        data: dataSeriesItem.map((d) => {
          return { x: 1, y: d.y };
        }),
        borderColor: colours[index],
        backgroundColor: colours[index],
        strokeWidth: "100px",
      };
    }),
  };

  return <Line options={options} data={data} />;
});
